import React, { FC } from 'react';

import { Currencies } from '@constants/constants';
import { getCurrencySymbol } from '@utils/utils';

import { Discount } from './DiscountLabelStyle';

export type DiscountRateType = 'percent' | 'value' | 'text';

interface DiscountLabelProps {
  discount: number | string;
  type?: DiscountRateType;
  currency?: string;
}

const SUPPORTED_CURRENCY_CODES = new Set([
  'TL',
  'TRY',
  '₺',
  'USD',
  '$',
  'EUR',
  '€',
  'GBP',
  '£',
]);

export const formatDiscountCurrency = (currency: string): string => {
  const normalizedCurrency = currency.trim().toUpperCase();

  return SUPPORTED_CURRENCY_CODES.has(normalizedCurrency)
    ? getCurrencySymbol(normalizedCurrency)
    : currency;
};

const DiscountLabel: FC<DiscountLabelProps> = ({
  discount,
  type = 'percent',
  currency = Currencies.TL,
}) => {
  const currencyLabel =
    type === 'value' ? formatDiscountCurrency(currency) : '';

  return (
    <Discount>
      {type === 'percent' ? '%' : ''}
      {discount} {type === 'text' ? '' : `${currencyLabel} İndirim`}
    </Discount>
  );
};

export default DiscountLabel;
